import { NavigationService } from '../../services/navigation.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { User } from '../../User';

@Component({
  selector: 'app-user-messages',
  templateUrl: './user-messages.component.html',
  styleUrls: ['./user-messages.component.css']
})
export class UserMessagesComponent implements OnInit {
  user: User;
  hasSevenSeriesCard: boolean;
  isUserHoldRoleAgent: boolean;
  hasMultipleAgentRoles: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.user = this.authService.user;
    this.hasSevenSeriesCard = 'true' === this.user.hasSevenSeriesCard;
    this.hasMultipleAgentRoles = 'true' === this.user.hasMultipleAgentRoles;
    this.isUserHoldRoleAgent = 'true' === sessionStorage.getItem('isHoldRoleAgent');
    this.authService.clearCookieFlag();
    this.router.navigate(['/users/messages']);
    this.navigationService.refreshNavigationEvent.emit(true);
  }

}
